import { Routes } from '@angular/router';

import { userMgmtRoute, userDialogRoute } from './';

import { UserRouteAccessService } from '../shared';
import { PurgeComponent } from './purge/purge.component';


export const adminState: Routes = [{
    path: '',
    data: {
        authorities: ['ROLE_INTERNAL']
    },
    canActivate: [UserRouteAccessService],
    children: [
        ...userMgmtRoute,
        {
            path: 'purge',
            component: PurgeComponent,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'purge.title'
            }
        }
    ]
},
...userDialogRoute
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/admin.route.ts